import { graphql } from "gql";

const INTERNAL_ADMIN_USER_ATTRIBUTE_LIST_QUERY = graphql(`
  query InternalAdminUserAttributeList(
    $organizationId: ID!
    $input: InternalAdminUserAttributeListInput!
  ) {
    internalAdminUserAttributeList(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminUserAttribute
    }
  }
`);

export default INTERNAL_ADMIN_USER_ATTRIBUTE_LIST_QUERY;
